export enum SOCKET_EVENTS {
  MOVE_CHILD = 'moveChild',
  ACTION_SCHEDULE = 'actionSchedule',
  FORCE_RELOAD = 'force_reload',
}
